// angular
import {ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
// commons
import {CommonsConfig} from './commons.config';
import {
    AsClassPipe,
    AsIdPipe,
    FullnamePipe,
    MapSizePipe,
    MapToArrayPipe,
    NumberFormatPipe,
    SortArrayPipe
} from './commons.pipe';
import {
    ApplicationNameDirective,
    ApplicationVersionDirective,
    BusyDirective,
    DisableControlDirective,
    FromYearDirective,
    MimeIconDirective,
    VarDirective
} from './commons.directive';
import {BusyService} from './busy.service';
import {StorageService} from './storage.service';
import {RefreshComponent} from './refresh/refresh.component';
import {I18nModule} from '../i18n/i18n.module';

@NgModule({
    imports: [
        CommonModule,
        I18nModule
    ],
    declarations: [
        FullnamePipe,
        AsIdPipe,
        AsClassPipe,
        MapToArrayPipe,
        SortArrayPipe,
        MapSizePipe,
        NumberFormatPipe,
        ApplicationVersionDirective,
        ApplicationNameDirective,
        FromYearDirective,
        BusyDirective,
        MimeIconDirective,
        DisableControlDirective,
        VarDirective,
        RefreshComponent
    ],
    exports: [
        FullnamePipe,
        AsIdPipe,
        AsClassPipe,
        MapToArrayPipe,
        SortArrayPipe,
        MapSizePipe,
        NumberFormatPipe,
        ApplicationVersionDirective,
        ApplicationNameDirective,
        FromYearDirective,
        BusyDirective,
        MimeIconDirective,
        DisableControlDirective,
        VarDirective,
        RefreshComponent
    ]
})
export class CommonsModule {

    /**
     * Configures the CommonsModule.
     *
     * @param config Module configuration
     * @return The module with the providers
     */
    static forRoot(config: CommonsConfig): ModuleWithProviders<CommonsModule> {
        return {
            ngModule: CommonsModule,
            providers: [
                {provide: CommonsConfig, useValue: config},
                // services
                BusyService,
                StorageService
                // NOTE: RefreshService is not provided here: any component making use of RefreshComponent
                // should provide its own instance of RefreshService with proper configuration
            ]
        };
    }
}
